import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import Home from '../components/Home'
import Mensaje from '../components/Mensaje'
import MensajeCorreoWiFi from '../components/MensajeCorreoWiFi'
import MensajeWifiTemporal from '../components/MensajeWifiTemporal'

import ConfirmarEmail from '../components/account/ConfirmarEmail'
import ConfirmarEmailExterno from '../components/account/ConfirmarEmailExterno'
import FacebookLogin from '../components/account/FacebookLogin'
import Login from '../components/account/Login'
import ReenviarCodigo from '../components/account/ReenviarCodigo'
import Register from '../components/account/Register'
import ResetPassword from '../components/account/ResetPassword'
import RestablecerPassword from '../components/account/RestablecerPassword'

import Categorias from '../components/cliente/Categorias'
import CompletarRegistro from '../components/cliente/CompletarRegistro'
import Direccion from '../components/cliente/Direccion'
import FechaNacimiento from '../components/cliente/FechaNacimiento'
import EstadoCivil from '../components/cliente/EstadoCivil'
import Contacto from '../components/cliente/Contacto'
import Transporte from '../components/cliente/Transporte'

import SubirFactura from '../components/facturas/SubirFactura'

import Sorteos from '../components/sorteos/Sorteos'

import Wifi from '../components/wifi/Wifi'

Vue.use(Router);

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/mensaje',
      name: 'mensaje',
      component: Mensaje,
      beforeEnter: (to, from, next) => {
        if (!store.getters.mensaje) {
          next({ name: 'home' })
        } else {
          next();
        }
      }
    },
    {
      path: '/wifi',
      name: 'wifi',
      component: Wifi
    },
    {
      path: '/mensajeCorreoWiFi',
      name: 'mensajeCorreoWiFi',
      component: MensajeCorreoWiFi
    },
    {
      path: '/mensajeWifiTemporal',
      name: 'mensajeWifiTemporal',
      component: MensajeWifiTemporal
    },    
    {
      path: '/account/register',
      name: 'register',
      component: Register,
      meta: { sinUsuario: true }
    },
    {
      path: '/account/resetpassword',
      name: 'resetpassword',
      component: ResetPassword,
      meta: { sinUsuario: true }
    },
    {
      path: '/account/restablecer-password',
      name: 'restablecer-password',
      component: RestablecerPassword,
      meta: {
        sinUsuario: true
      }
    },
    {
      path: '/account/confirmar-email',
      name: 'confirmar-email',
      component: ConfirmarEmail,
      meta: { sinUsuario: true }
    },
    {
      path: '/account/login',
      name: 'login',
      component: Login,
      meta: { sinUsuario: true }
    },
    {
      path: '/account/reenviar-codigo',
      name: 'reenviar-codigo',
      component: ReenviarCodigo
    },
    {
      path: '/account/facebook-login',
      name: 'facebook-login',
      component: FacebookLogin
    },
    {
      path: '/facebook-login-url',
      name: 'facebook-login-url',
      beforeEnter() { 
        location.href = 'https://www.facebook.com/v2.12/dialog/oauth?&response_type=token&client_id=179275739257232&redirect_uri=https://clientes.lacentral.com.co/account/facebook-login' 
      }
    },
    {
      path: '/pagina-principal',
      name: 'pagina-principal',
      beforeEnter() { 
        location.href = 'https://clientes.lacentral.com.co' 
      }
    },
    {
      path: '/account/confirmar-email-externo',
      name: 'confirmar-email-externo',
      component: ConfirmarEmailExterno
    },
    {
      path: '/cliente/completar-registro',
      name: 'completar-registro',
      component: CompletarRegistro,
      meta: { requiresAuth: true }
    },
    {
      path: '/cliente/fecha-nacimiento',
      name: 'fecha-nacimiento',
      component: FechaNacimiento,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/cliente/estado-civil',
      name: 'estado-civil',
      component: EstadoCivil,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/cliente/contacto',
      name: 'contacto',
      component: Contacto,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/cliente/direccion',
      name: 'direccion',
      component: Direccion,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/cliente/transporte',
      name: 'transporte',
      component: Transporte,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/cliente/categorias',
      name: 'categorias',
      component: Categorias,
      meta: { requiresAuth: true, clienteRequerido: true }
    },    
    {
      path: '/facturas/subir-factura',
      name: 'subir-factura',
      component: SubirFactura,
      meta: { requiresAuth: true, clienteRequerido: true }
    },
    {
      path: '/sorteos/sorteos',
      name: 'sorteos',
      component: Sorteos,
      meta: { requiresAuth: true, clienteRequerido: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.account.token) {
      next({ 
        name: 'login',
        query: { redirect: to.fullPath }
      });
      return
    } 
    else if(to.matched.some(record => record.meta.clienteRequerido)) {
      if (!store.getters.cliente) {
        next({ 
          name: 'completar-registro',
          query: { redirect: to.fullPath }
        });
        return
      } 
    }
  }  

  if (to.matched.some(record => record.meta.sinUsuario)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.token) {
      next({ 
        name: 'home',
        query: { redirect: to.fullPath }
      });
      return
    } 
  }  

  next(); // make sure to always call next()!
});

export default router;